import SalonProfile from './SalonProfile';

export default SalonProfile;
